import Locations from './Locations';
import {ActionCreators} from '../../actions';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getUser, getClient, getLocation} from '../../reducers/rootReducer';

const mapStateToProps = state => {
  const {user, users} = getUser(state);
  const {clients, client} = getClient(state);
  const {locations, location, addingLocation, addedLocation, updatedLocation, updatingLocation} = getLocation(state);

  return {
    user,
    users,
    clients,
    client,
    locations,
    location,
    addedLocation,
    addingLocation,
    updatingLocation,
    updatedLocation
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(ActionCreators, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Locations);
